/** Connection-workspace tab ids — the `?tab` search param on
 *  `/deliveries/connections/$connectionId`. Ordered as the delivery journey reads:
 *  configure → generate & review → runs → per-product investigation → what's
 *  broken and why → history. `blocked` (BE PR #628) is connector-agnostic
 *  server-side but, like Products/History, is surfaced only in this
 *  (currently Meta-gated) workspace. */
export const CONNECTION_WORKSPACE_TABS = [
  'setup',
  'feeds',
  'runs',
  'products',
  'blocked',
  'coverage',
  'history',
] as const;
export type ConnectionWorkspaceTab = (typeof CONNECTION_WORKSPACE_TABS)[number];

/** Default tab when `?tab` is absent or invalid. */
export const DEFAULT_CONNECTION_WORKSPACE_TAB: ConnectionWorkspaceTab = 'setup';
